module.exports = "pegasus/assets/theme4/facebook-icon.png";